export const ROUTES = {
    EDIT_PROFILE: 'EDIT_PROFILE',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    TERMS_CONDITIONS: 'TERMS_CONDITIONS',
    PRIVACY_POLICY: 'PRIVACY_POLICY',
}